import { SVGProps } from "react";

const HeaderClockIcon = ({ ...props }: SVGProps<SVGSVGElement> = {}) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMin meet"
    aria-hidden={true}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.32837 0.333008C2.56837 0.333008 0.333374 2.57301 0.333374 5.33301C0.333374 8.09301 2.56837 10.333 5.32837 10.333C8.09337 10.333 10.3334 8.09301 10.3334 5.33301C10.3334 2.57301 8.09337 0.333008 5.32837 0.333008ZM5.33337 9.33301C3.12337 9.33301 1.33337 7.54301 1.33337 5.33301C1.33337 3.12302 3.12337 1.33302 5.33337 1.33302C7.54337 1.33302 9.33337 3.12302 9.33337 5.33301C9.33337 7.54301 7.54337 9.33301 5.33337 9.33301ZM4.83337 2.83302H5.58337V5.45802L7.83337 6.79302L7.45837 7.40802L4.83337 5.83302V2.83302Z"
      fill="#727272"
    />
  </svg>
);

export default HeaderClockIcon;
